import Box from 'UIKit/Box/Box'
import React, { useMemo } from 'react'
import Progress from '..'
import { ProgressProps } from '../types'
import { StyledMarkPointContainer } from './styled'

interface MarkedProgressProps {
  value: number
  markedList: { value: number }[]
  markComponent: React.FC<{ item: any; isActive: boolean }>
}

const MarkedProgress: React.FC<MarkedProgressProps & ProgressProps> = ({
  value,
  markedList,
  markComponent: MarkComponent,
  ...props
}) => {
  const latestStepOverPoint = useMemo(
    () =>
      markedList.reduce(
        (progressPercent, { value: pointValue }) => (value >= pointValue ? pointValue : progressPercent),
        0,
      ),
    [markedList, value],
  )
  return (
    <Box position="relative">
      <Progress showPointer={false} variant="round" primaryStep={value} {...props} />
      <StyledMarkPointContainer>
        {markedList?.map((item) => (
          <Box position="absolute" left={`${item.value}%`}>
            <MarkComponent item={item} isActive={latestStepOverPoint >= Number(item.value)} />
          </Box>
        ))}
      </StyledMarkPointContainer>
    </Box>
  )
}

export default MarkedProgress
